/** Service Worker が通知タップ時に postMessage する組織スコープ付き遷移の検証（設計書 §9.6）。 */
export const ORGANIZATION_NAVIGATION_MESSAGE_TYPE =
  'line-ban:organization-navigation'

const NAVIGATION_TARGET_PATTERN =
  /^\/o\/(\d+)\/(chat|inquiry-chat)\?channel=([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i

export type OrganizationNavigationMessage = {
  organizationId: number
  path: string
}

/** 形が合わない・組織IDが一致しない・許可されていないパスは null。 */
export function parseOrganizationNavigationMessage(
  value: unknown,
): OrganizationNavigationMessage | null {
  if (typeof value !== 'object' || value === null) return null

  const message = value as Record<string, unknown>
  if (message.type !== ORGANIZATION_NAVIGATION_MESSAGE_TYPE) return null

  const organizationId = message.organizationId
  if (
    typeof organizationId !== 'number' ||
    !Number.isSafeInteger(organizationId) ||
    organizationId <= 0
  ) {
    return null
  }

  const path = message.path
  if (typeof path !== 'string') return null

  const matched = NAVIGATION_TARGET_PATTERN.exec(path)
  if (!matched) return null
  if (Number(matched[1]) !== organizationId) return null

  return { organizationId, path }
}
